module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_nagai_hiratsuka-e2ad366ebe8753506c3b3b08d2769a16.jpg";